export const SCOPE = 'module:trends';

export const INIT = `${SCOPE}/INIT`;
export const RESET = `${SCOPE}/RESET`;
export const SAVE_STATE = `${SCOPE}/SAVE_STATE`;
export const CHANGE_MODE = `${SCOPE}/CHANGE_MODE`;
